"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderCardList = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const action_card_1 = require("@kyruus/action-card");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ProviderCardList = (0, styled_1.default)(action_card_1.ActionCardList) `
  width: 100%;
  flex: 1;
  margin-left: auto;
  margin-right: auto;
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    margin-left: unset;
    margin-right: unset;
  }
  & > span {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')} ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }
`;
//# sourceMappingURL=MiniProviderBookAndReferList.styles.js.map